module.exports = __webpack_public_path__ + "img/baner.fe042f07.jpg";